//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'VisitList',
  data() {
    return {
      activeIndex: null,
      list: [],
      user: {}
    }
  },
  components: {
  },
  mounted() {
    this.getUsersByOpenId()
  },
  methods: {
    getDate (createdAt) {
      if (!createdAt) {
        return
      }
      return moment(createdAt).format('YYYY-MM-DD')
    },
    getBirthDate (IDCard) {
      if (!IDCard) {
        return ''
      }
      var year = IDCard.substring(6, 10)
      var month = IDCard.substring(10, 12)
      var day = IDCard.substring(12, 14)
      var birthDate = year + '年' + month + '月' + day + '日'
      return birthDate
    },
    getUsersByOpenId () {
      console.log(this.$route)
      this.$store.httpDispatch({})('addLog', {
        action: '查看',
        type: '用戶信息',
        from: 'client',
        openid: this.$route.params.id
      }).catch((err) => {
        console.log(err)
      })
      this.$store.httpDispatch({})('getUserByDoctorId', {
        openid: this.$route.params.id
      })
      .then((res) => {
        if (res.data.code === 0) {
          this.user = res.data.data.retUser
          this.getVisits()
        }
      })
    },
    getVisits () {
      axios.get('/api/admin/visits/all', {
        params: {
          openid: this.user.openid
        }
      }).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.list = res.data.data.visits
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
